import { ComponentPropsWithoutRef } from 'react';

export function Code500(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="876" height="1080" viewBox="0 0 876 1080" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M200.199 633.555C178.16 633.555 158.669 627.275 141.725 614.715C124.899 602.036 114.65 586.159 110.977 567.082L142.969 556.773C146.405 569.333 153.455 579.642 164.119 587.699C174.783 595.757 186.81 599.785 200.199 599.785C214.655 599.785 226.8 594.868 236.635 585.033C246.469 575.199 251.387 563.113 251.387 548.775C251.387 533.846 246.469 521.404 236.635 511.451C226.919 501.38 214.773 496.344 200.199 496.344C191.312 496.344 182.9 497.884 174.961 500.965C167.141 503.927 160.861 508.015 156.121 513.229L125.906 506.652L137.104 375.129H271.471V408.365H168.385L161.631 478.57C166.489 474.542 172.828 471.342 180.648 468.973C188.469 466.603 196.408 465.418 204.465 465.418C228.281 465.418 248.069 473.298 263.828 489.057C279.587 504.697 287.467 524.84 287.467 549.486C287.467 560.98 285.156 571.94 280.535 582.367C276.033 592.794 269.871 601.74 262.051 609.205C254.349 616.67 245.107 622.594 234.324 626.979C223.542 631.363 212.167 633.555 200.199 633.555Z"
        fill="#9E8AD9"
      />
      <path
        d="M438.023 633.605C416.385 633.585 395.105 627.95 376.168 617.227C357.231 606.504 341.255 591.04 329.729 572.28C318.204 553.52 311.505 532.075 310.258 509.946C309.011 487.816 313.256 465.723 322.598 445.729C323.33 444.151 324.644 442.934 326.25 442.347C327.857 441.761 329.626 441.851 331.168 442.599C332.709 443.347 333.898 444.692 334.473 446.338C335.047 447.983 334.961 449.795 334.232 451.375C326.669 467.298 322.792 484.792 322.904 502.5C322.904 525.9 329.681 548.774 342.378 568.226C355.075 587.678 373.12 602.834 394.229 611.774C415.338 620.714 438.561 623.038 460.96 618.45C483.358 613.862 503.925 602.569 520.055 586.001C536.185 569.432 547.154 548.334 551.573 525.376C555.992 502.418 553.663 478.633 544.879 457.032C536.096 435.431 521.254 416.985 502.233 404.03C483.211 391.074 460.865 384.192 438.023 384.254C414.959 384.113 392.409 391.229 373.421 404.642C372.001 405.598 370.267 405.937 368.602 405.584C366.936 405.231 365.476 404.215 364.543 402.76C363.609 401.304 363.278 399.528 363.622 397.822C363.967 396.116 364.959 394.62 366.38 393.664C385.66 380.413 408.09 372.775 431.278 371.565C454.464 370.354 477.536 375.617 498.031 386.791C518.526 397.965 535.674 414.632 547.645 435.01C559.617 455.389 565.961 478.715 566 502.5C565.912 537.243 552.4 570.537 528.419 595.104C504.437 619.672 471.938 633.514 438.023 633.605Z"
        fill="#9E8AD9"
      />
      <path
        d="M438.005 605.695C418.083 605.695 398.608 599.643 382.043 588.304C365.479 576.965 352.568 560.849 344.944 541.994C337.32 523.138 335.325 502.39 339.212 482.373C343.099 462.356 352.692 443.969 366.779 429.537C380.866 415.106 398.815 405.278 418.354 401.296C437.893 397.315 458.147 399.358 476.552 407.168C494.958 414.979 510.69 428.205 521.758 445.174C532.827 462.144 538.734 482.095 538.734 502.504C538.736 503.37 538.571 504.228 538.249 505.029C537.926 505.83 537.453 506.557 536.855 507.17C536.258 507.783 535.549 508.269 534.768 508.601C533.987 508.933 533.15 509.104 532.305 509.104C531.459 509.104 530.622 508.933 529.841 508.601C529.061 508.269 528.351 507.783 527.754 507.17C527.156 506.557 526.683 505.83 526.361 505.029C526.038 504.228 525.874 503.37 525.875 502.504C525.875 484.701 520.721 467.296 511.067 452.493C501.412 437.69 487.688 426.152 471.632 419.339C455.576 412.526 437.908 410.743 420.863 414.216C403.818 417.69 388.161 426.263 375.872 438.852C363.583 451.441 355.214 467.481 351.824 484.943C348.433 502.404 350.173 520.503 356.824 536.952C363.475 553.401 374.737 567.459 389.187 577.351C403.638 587.242 420.627 592.522 438.005 592.522C452.422 592.588 466.629 588.983 479.349 582.029C492.067 575.076 502.9 564.993 510.873 552.688C511.335 551.967 511.932 551.346 512.628 550.862C513.324 550.377 514.108 550.037 514.932 549.863C515.757 549.688 516.606 549.681 517.433 549.844C518.26 550.005 519.048 550.332 519.752 550.806C520.455 551.28 521.061 551.891 521.535 552.604C522.008 553.317 522.339 554.12 522.509 554.964C522.68 555.809 522.686 556.679 522.529 557.527C522.37 558.374 522.051 559.18 521.589 559.902C512.401 573.981 499.968 585.525 485.39 593.512C470.812 601.498 454.537 605.683 438.005 605.695Z"
        fill="#9E8AD9"
      />
      <path
        d="M438.018 578.085C428.33 578.127 418.732 576.177 409.792 572.353C400.851 568.528 392.751 562.905 385.969 555.817C375.671 545.234 368.658 531.766 365.814 517.109C362.97 502.453 364.421 487.262 369.985 473.447C375.548 459.634 384.977 447.815 397.082 439.477C409.188 431.14 423.431 426.657 438.018 426.593C447.706 426.552 457.304 428.501 466.244 432.326C475.184 436.151 483.285 441.774 490.066 448.862C490.648 449.46 491.112 450.169 491.427 450.949C491.743 451.729 491.905 452.566 491.905 453.41C491.905 454.255 491.743 455.091 491.427 455.872C491.112 456.652 490.648 457.361 490.066 457.958C489.483 458.556 488.791 459.029 488.029 459.352C487.267 459.676 486.451 459.842 485.627 459.842C484.802 459.842 483.986 459.676 483.224 459.352C482.463 459.029 481.77 458.555 481.187 457.958C475.528 452.145 468.798 447.542 461.387 444.419C453.975 441.296 446.032 439.714 438.018 439.767C421.858 439.806 406.358 446.338 394.848 457.958C386.292 466.688 380.461 477.825 378.096 489.957C375.73 502.088 376.937 514.666 381.563 526.092C386.189 537.52 394.025 547.281 404.077 554.137C414.128 560.993 425.942 564.634 438.018 564.599C447.02 564.623 455.916 562.605 464.066 558.688C472.217 554.772 479.419 549.055 485.156 541.948C490.893 534.841 495.023 526.521 497.248 517.584C499.473 508.648 499.739 499.318 498.026 490.264C497.864 489.44 497.862 488.591 498.02 487.765C498.178 486.94 498.494 486.156 498.949 485.456C499.404 484.755 499.989 484.154 500.671 483.686C501.353 483.218 502.118 482.891 502.923 482.727C503.728 482.561 504.557 482.561 505.362 482.725C506.167 482.888 506.933 483.213 507.616 483.68C508.298 484.147 508.885 484.747 509.341 485.447C509.796 486.145 510.114 486.93 510.273 487.755C512.613 499.879 511.994 512.407 508.468 524.226C504.943 536.046 498.621 546.79 490.066 555.503C483.343 562.692 475.26 568.402 466.311 572.285C457.363 576.167 447.736 578.141 438.018 578.085Z"
        fill="#9E8AD9"
      />
      <path
        d="M438.011 547.043C429.445 547.079 421.064 544.505 413.931 539.649C406.798 534.792 401.237 527.871 397.955 519.767C394.672 511.664 393.817 502.742 395.498 494.139C397.179 485.535 401.319 477.639 407.394 471.453C408.571 470.247 410.168 469.569 411.833 469.569C413.498 469.569 415.095 470.247 416.272 471.453C417.45 472.659 418.111 474.296 418.111 476.001C418.111 477.706 417.45 479.343 416.272 480.549C411.178 485.875 408.115 492.895 407.641 500.337C407.166 507.779 409.31 515.148 413.686 521.108C418.061 527.068 424.375 531.224 431.486 532.823C438.596 534.421 446.029 533.356 452.44 529.821C458.849 526.286 463.808 520.514 466.419 513.553C469.031 506.592 469.119 498.903 466.671 491.881C464.221 484.858 459.396 478.967 453.071 475.277C446.745 471.587 439.338 470.341 432.194 471.767C430.57 472.096 428.887 471.752 427.511 470.811C426.136 469.87 425.181 468.408 424.856 466.746C424.532 465.084 424.864 463.359 425.781 461.948C426.697 460.537 428.123 459.556 429.744 459.221C435.673 458.018 441.784 458.101 447.68 459.465C453.577 460.829 459.129 463.443 463.979 467.14C468.829 470.836 472.869 475.532 475.84 480.925C478.81 486.319 480.644 492.29 481.225 498.454C481.805 504.618 481.118 510.839 479.209 516.714C477.299 522.59 474.21 527.99 470.138 532.568C466.067 537.145 461.104 540.798 455.57 543.291C450.037 545.784 444.055 547.062 438.011 547.043Z"
        fill="#9E8AD9"
      />
      <path
        d="M717.978 633.605C696.34 633.585 675.06 627.95 656.123 617.227C637.186 606.504 621.21 591.04 609.684 572.28C598.159 553.52 591.46 532.075 590.213 509.946C588.966 487.816 593.211 465.723 602.553 445.729C603.285 444.151 604.599 442.934 606.205 442.347C607.812 441.761 609.581 441.851 611.123 442.599C612.664 443.347 613.853 444.692 614.428 446.338C615.002 447.983 614.916 449.795 614.187 451.375C606.624 467.298 602.747 484.792 602.859 502.5C602.859 525.9 609.636 548.774 622.333 568.226C635.03 587.678 653.075 602.834 674.184 611.774C695.293 620.714 718.516 623.038 740.915 618.45C763.314 613.862 783.88 602.569 800.01 586.001C816.14 569.432 827.109 548.334 831.528 525.376C835.947 502.418 833.618 478.633 824.834 457.032C816.051 435.431 801.21 416.985 782.188 404.03C763.166 391.074 740.82 384.192 717.978 384.254C694.914 384.113 672.364 391.229 653.377 404.642C651.956 405.598 650.222 405.937 648.557 405.584C646.892 405.231 645.432 404.215 644.498 402.76C643.564 401.304 643.233 399.528 643.577 397.822C643.922 396.116 644.914 394.62 646.335 393.664C665.615 380.413 688.045 372.775 711.233 371.565C734.419 370.354 757.492 375.617 777.986 386.791C798.481 397.965 815.629 414.632 827.6 435.01C839.572 455.389 845.916 478.715 845.955 502.5C845.867 537.243 832.355 570.537 808.374 595.104C784.392 619.672 751.893 633.514 717.978 633.605Z"
        fill="#9E8AD9"
      />
      <path
        d="M717.96 605.695C698.038 605.695 678.563 599.643 661.998 588.304C645.434 576.965 632.523 560.849 624.899 541.994C617.275 523.138 615.28 502.39 619.167 482.373C623.054 462.356 632.647 443.969 646.734 429.537C660.821 415.106 678.77 405.278 698.309 401.296C717.848 397.315 738.102 399.358 756.507 407.168C774.913 414.979 790.645 428.205 801.713 445.174C812.782 462.144 818.689 482.095 818.689 502.504C818.691 503.37 818.526 504.228 818.204 505.029C817.881 505.83 817.408 506.557 816.81 507.17C816.213 507.783 815.505 508.269 814.723 508.601C813.942 508.933 813.105 509.104 812.26 509.104C811.414 509.104 810.577 508.933 809.797 508.601C809.016 508.269 808.306 507.783 807.709 507.17C807.111 506.557 806.638 505.83 806.316 505.029C805.993 504.228 805.829 503.37 805.83 502.504C805.83 484.701 800.677 467.296 791.022 452.493C781.367 437.69 767.643 426.152 751.587 419.339C735.531 412.526 717.863 410.743 700.818 414.216C683.773 417.69 668.116 426.263 655.827 438.852C643.538 451.441 635.169 467.481 631.779 484.943C628.388 502.404 630.129 520.503 636.779 536.952C643.43 553.401 654.692 567.459 669.143 577.351C683.593 587.242 700.582 592.522 717.96 592.522C732.377 592.588 746.584 588.983 759.304 582.029C772.022 575.076 782.855 564.993 790.828 552.688C791.29 551.967 791.887 551.346 792.583 550.862C793.279 550.377 794.063 550.037 794.887 549.863C795.712 549.688 796.561 549.681 797.388 549.844C798.215 550.005 799.003 550.332 799.707 550.806C800.41 551.28 801.016 551.891 801.49 552.604C801.963 553.317 802.294 554.12 802.464 554.964C802.635 555.809 802.641 556.679 802.484 557.527C802.326 558.374 802.006 559.18 801.544 559.902C792.356 573.981 779.923 585.525 765.345 593.512C750.767 601.498 734.492 605.683 717.96 605.695Z"
        fill="#9E8AD9"
      />
      <path
        d="M717.973 578.085C708.285 578.127 698.687 576.177 689.747 572.353C680.806 568.528 672.706 562.905 665.924 555.817C655.626 545.234 648.613 531.766 645.769 517.109C642.925 502.453 644.376 487.262 649.94 473.447C655.504 459.634 664.932 447.815 677.037 439.477C689.143 431.14 703.386 426.657 717.973 426.593C727.661 426.552 737.259 428.501 746.199 432.326C755.139 436.151 763.24 441.774 770.021 448.862C770.604 449.46 771.067 450.169 771.382 450.949C771.698 451.729 771.86 452.566 771.86 453.41C771.86 454.255 771.698 455.091 771.382 455.872C771.067 456.652 770.604 457.361 770.021 457.958C769.438 458.556 768.746 459.029 767.984 459.352C767.222 459.676 766.406 459.842 765.582 459.842C764.757 459.842 763.941 459.676 763.179 459.352C762.418 459.029 761.725 458.555 761.142 457.958C755.483 452.145 748.753 447.542 741.342 444.419C733.93 441.296 725.987 439.714 717.973 439.767C701.813 439.806 686.313 446.338 674.803 457.958C666.247 466.688 660.416 477.825 658.051 489.957C655.685 502.088 656.892 514.666 661.518 526.092C666.144 537.52 673.98 547.281 684.032 554.137C694.083 560.993 705.897 564.634 717.973 564.599C726.975 564.623 735.871 562.605 744.021 558.688C752.172 554.772 759.374 549.055 765.111 541.948C770.848 534.841 774.978 526.521 777.203 517.584C779.429 508.648 779.694 499.318 777.981 490.264C777.819 489.44 777.817 488.591 777.975 487.765C778.134 486.94 778.449 486.156 778.904 485.456C779.359 484.755 779.944 484.154 780.626 483.686C781.308 483.218 782.073 482.891 782.878 482.727C783.683 482.561 784.512 482.561 785.317 482.725C786.122 482.888 786.888 483.213 787.571 483.68C788.254 484.147 788.84 484.747 789.296 485.447C789.751 486.145 790.069 486.93 790.228 487.755C792.568 499.879 791.949 512.407 788.423 524.226C784.898 536.046 778.576 546.79 770.021 555.503C763.298 562.692 755.215 568.402 746.266 572.285C737.318 576.167 727.691 578.141 717.973 578.085Z"
        fill="#9E8AD9"
      />
      <path
        d="M717.966 547.043C709.4 547.079 701.019 544.505 693.886 539.649C686.753 534.792 681.192 527.871 677.91 519.767C674.627 511.664 673.772 502.742 675.453 494.139C677.134 485.535 681.274 477.639 687.349 471.453C688.526 470.247 690.123 469.569 691.788 469.569C693.453 469.569 695.05 470.247 696.227 471.453C697.405 472.659 698.066 474.296 698.066 476.001C698.066 477.706 697.405 479.343 696.227 480.549C691.133 485.875 688.07 492.895 687.596 500.337C687.121 507.779 689.266 515.148 693.641 521.108C698.016 527.068 704.331 531.224 711.441 532.823C718.551 534.421 725.985 533.356 732.395 529.821C738.804 526.286 743.763 520.514 746.374 513.553C748.986 506.592 749.074 498.903 746.626 491.881C744.176 484.858 739.351 478.967 733.026 475.277C726.7 471.587 719.293 470.341 712.149 471.767C710.525 472.096 708.842 471.752 707.466 470.811C706.091 469.87 705.136 468.408 704.811 466.746C704.487 465.084 704.819 463.359 705.736 461.948C706.652 460.537 708.078 459.556 709.699 459.221C715.629 458.018 721.739 458.101 727.635 459.465C733.532 460.829 739.084 463.443 743.934 467.14C748.784 470.836 752.824 475.532 755.795 480.925C758.765 486.319 760.599 492.29 761.18 498.454C761.761 504.618 761.073 510.839 759.164 516.714C757.254 522.59 754.165 527.99 750.093 532.568C746.022 537.145 741.059 540.798 735.525 543.291C729.992 545.784 724.01 547.062 717.966 547.043Z"
        fill="#9E8AD9"
      />
      <g filter="url(#filter0_d_2361_7302)">
        <path
          d="M438.496 700.515C548.674 700.515 637.881 611.637 637.746 502C637.61 392.363 548.183 303.485 438.005 303.485C327.827 303.485 238.62 392.363 238.755 502C238.891 611.637 328.318 700.515 438.496 700.515Z"
          fill="#F2F0FF"
          fillOpacity="0.13"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_2361_7302)">
        <path
          d="M0 591.5C0 574.931 13.4315 561.5 30 561.5H112C128.569 561.5 142 574.931 142 591.5V623.5H30C13.4315 623.5 0 610.069 0 593.5V591.5Z"
          fill="url(#paint0_linear_2361_7302)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter2_d_2361_7302)">
        <path
          d="M648 737.5H756C773.121 737.5 787 751.379 787 768.5C787 785.621 773.121 799.5 756 799.5H688C665.909 799.5 648 781.591 648 759.5V737.5Z"
          fill="url(#paint1_linear_2361_7302)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter3_d_2361_7302)">
        <path
          d="M518 225.5C518 208.931 531.431 195.5 548 195.5H674C690.569 195.5 704 208.931 704 225.5V227.5C704 244.069 690.569 257.5 674 257.5H518V225.5Z"
          fill="url(#paint2_linear_2361_7302)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <mask id="path-14-inside-1_2361_7302" fill="white">
        <path d="M600.176 449.376C602.277 448.694 604.538 449.844 605.171 451.96C612.294 475.754 614.255 500.795 610.923 525.408C610.627 527.597 608.572 529.084 606.39 528.738L543.632 518.773C541.45 518.426 539.97 516.377 540.232 514.184C541.835 500.73 540.767 487.091 537.089 474.051C536.489 471.925 537.632 469.671 539.733 468.989L600.176 449.376Z" />
      </mask>
      <path
        d="M600.176 449.376C602.277 448.694 604.538 449.844 605.171 451.96C612.294 475.754 614.255 500.795 610.923 525.408C610.627 527.597 608.572 529.084 606.39 528.738L543.632 518.773C541.45 518.426 539.97 516.377 540.232 514.184C541.835 500.73 540.767 487.091 537.089 474.051C536.489 471.925 537.632 469.671 539.733 468.989L600.176 449.376Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-14-inside-1_2361_7302)"
      />
      <mask id="path-15-inside-2_2361_7302" fill="white">
        <path d="M606.442 528.41C608.625 528.752 610.121 530.8 609.729 532.974C605.321 557.416 595.745 580.637 581.642 601.082C580.388 602.9 577.883 603.298 576.093 602.002L524.626 564.732C522.837 563.436 522.444 560.939 523.669 559.101C531.184 547.827 536.399 535.18 539.016 521.886C539.443 519.719 541.482 518.225 543.664 518.567L606.442 528.41Z" />
      </mask>
      <path
        d="M606.442 528.41C608.625 528.752 610.121 530.8 609.729 532.974C605.321 557.416 595.745 580.637 581.642 601.082C580.388 602.9 577.883 603.298 576.093 602.002L524.626 564.732C522.837 563.436 522.444 560.939 523.669 559.101C531.184 547.827 536.399 535.18 539.016 521.886C539.443 519.719 541.482 518.225 543.664 518.567L606.442 528.41Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-15-inside-2_2361_7302)"
      />
      <mask id="path-16-inside-3_2361_7302" fill="white">
        <path d="M576.066 602.041C577.854 603.337 578.257 605.841 576.921 607.6C561.89 627.373 542.812 643.71 520.961 655.518C519.018 656.568 516.605 655.784 515.6 653.817L486.679 597.235C485.673 595.268 486.457 592.865 488.384 591.784C500.199 585.154 510.59 576.256 518.96 565.602C520.325 563.864 522.82 563.46 524.609 564.756L576.066 602.041Z" />
      </mask>
      <path
        d="M576.066 602.041C577.854 603.337 578.257 605.841 576.921 607.6C561.89 627.373 542.812 643.71 520.961 655.518C519.018 656.568 516.605 655.784 515.6 653.817L486.679 597.235C485.673 595.268 486.457 592.865 488.384 591.784C500.199 585.154 510.59 576.256 518.96 565.602C520.325 563.864 522.82 563.46 524.609 564.756L576.066 602.041Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-16-inside-3_2361_7302)"
      />
      <mask id="path-17-inside-4_2361_7302" fill="white">
        <path d="M516.139 653.54C517.152 655.504 516.383 657.921 514.396 658.888C492.066 669.762 467.671 675.743 442.844 676.433C440.636 676.494 438.836 674.707 438.825 672.498L438.517 608.954C438.507 606.745 440.29 604.953 442.497 604.857C456.033 604.265 469.319 601.007 481.594 595.27C483.595 594.335 486.005 595.098 487.017 597.062L516.139 653.54Z" />
      </mask>
      <path
        d="M516.139 653.54C517.152 655.504 516.383 657.921 514.396 658.888C492.066 669.762 467.671 675.743 442.844 676.433C440.636 676.494 438.836 674.707 438.825 672.498L438.517 608.954C438.507 606.745 440.29 604.953 442.497 604.857C456.033 604.265 469.319 601.007 481.594 595.27C483.595 594.335 486.005 595.098 487.017 597.062L516.139 653.54Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-17-inside-4_2361_7302)"
      />
      <path
        d="M438 402.5C438 400.291 439.792 398.492 441.999 398.577C462.446 399.368 482.233 406.204 498.836 418.267C515.438 430.329 528.055 447.036 535.125 466.237C535.888 468.31 534.731 470.57 532.63 471.253L499.88 481.894C497.779 482.576 495.535 481.42 494.716 479.369C490.453 468.683 483.245 459.392 473.893 452.597C464.542 445.803 453.477 441.819 441.997 441.066C439.793 440.921 438 439.144 438 436.935L438 402.5Z"
        fill="#9E8AD9"
        stroke="#483389"
      />
      <mask id="path-19-inside-5_2361_7302" fill="white">
        <path d="M532.591 471.133C534.691 470.448 536.957 471.593 537.561 473.718C541.651 488.116 542.574 503.245 540.246 518.062C537.711 534.197 531.394 549.504 521.81 562.73C512.226 575.956 499.648 586.726 485.104 594.16C471.749 600.986 457.085 604.82 442.13 605.418C439.922 605.506 438.128 603.709 438.126 601.5L438.082 567.065C438.079 564.856 439.87 563.076 442.074 562.929C450.329 562.377 458.4 560.152 465.792 556.374C474.372 551.988 481.793 545.634 487.448 537.831C493.102 530.027 496.83 520.997 498.325 511.477C499.613 503.276 499.214 494.913 497.168 486.897C496.622 484.757 497.755 482.501 499.855 481.816L532.591 471.133Z" />
      </mask>
      <path
        d="M532.591 471.133C534.691 470.448 536.957 471.593 537.561 473.718C541.651 488.116 542.574 503.245 540.246 518.062C537.711 534.197 531.394 549.504 521.81 562.73C512.226 575.956 499.648 586.726 485.104 594.16C471.749 600.986 457.085 604.82 442.13 605.418C439.922 605.506 438.128 603.709 438.126 601.5L438.082 567.065C438.079 564.856 439.87 563.076 442.074 562.929C450.329 562.377 458.4 560.152 465.792 556.374C474.372 551.988 481.793 545.634 487.448 537.831C493.102 530.027 496.83 520.997 498.325 511.477C499.613 503.276 499.214 494.913 497.168 486.897C496.622 484.757 497.755 482.501 499.855 481.816L532.591 471.133Z"
        fill="#9E8AD9"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-19-inside-5_2361_7302)"
      />
      <mask
        id="mask0_2361_7302"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="245"
        y="156"
        width="603"
        height="4"
      >
        <circle cx="846" cy="158.241" r="1.5" transform="rotate(-180 846 158.241)" fill="#F24C84" />
        <circle cx="837.905" cy="158.241" r="1.5" transform="rotate(-180 837.905 158.241)" fill="#F24C84" />
        <circle cx="829.811" cy="158.241" r="1.5" transform="rotate(-180 829.811 158.241)" fill="#F24C84" />
        <circle cx="821.716" cy="158.241" r="1.5" transform="rotate(-180 821.716 158.241)" fill="#F24C84" />
        <circle cx="813.622" cy="158.241" r="1.5" transform="rotate(-180 813.622 158.241)" fill="#F24C84" />
        <circle cx="805.527" cy="158.241" r="1.5" transform="rotate(-180 805.527 158.241)" fill="#F24C84" />
        <circle cx="797.433" cy="158.241" r="1.5" transform="rotate(-180 797.433 158.241)" fill="#F24C84" />
        <circle cx="789.338" cy="158.241" r="1.5" transform="rotate(-180 789.338 158.241)" fill="#F24C84" />
        <circle cx="781.243" cy="158.241" r="1.5" transform="rotate(-180 781.243 158.241)" fill="#F24C84" />
        <circle cx="773.148" cy="158.241" r="1.5" transform="rotate(-180 773.148 158.241)" fill="#F24C84" />
        <circle cx="765.054" cy="158.241" r="1.5" transform="rotate(-180 765.054 158.241)" fill="#F24C84" />
        <circle cx="756.959" cy="158.241" r="1.5" transform="rotate(-180 756.959 158.241)" fill="#F24C84" />
        <circle cx="748.865" cy="158.241" r="1.5" transform="rotate(-180 748.865 158.241)" fill="#F24C84" />
        <circle cx="740.771" cy="158.241" r="1.5" transform="rotate(-180 740.771 158.241)" fill="#F24C84" />
        <circle cx="732.676" cy="158.241" r="1.5" transform="rotate(-180 732.676 158.241)" fill="#F24C84" />
        <circle cx="724.581" cy="158.241" r="1.5" transform="rotate(-180 724.581 158.241)" fill="#F24C84" />
        <circle cx="716.486" cy="158.241" r="1.5" transform="rotate(-180 716.486 158.241)" fill="#F24C84" />
        <circle cx="708.392" cy="158.241" r="1.5" transform="rotate(-180 708.392 158.241)" fill="#F24C84" />
        <circle cx="700.297" cy="158.241" r="1.5" transform="rotate(-180 700.297 158.241)" fill="#F24C84" />
        <circle cx="692.203" cy="158.241" r="1.5" transform="rotate(-180 692.203 158.241)" fill="#F24C84" />
        <circle cx="684.108" cy="158.241" r="1.5" transform="rotate(-180 684.108 158.241)" fill="#F24C84" />
        <circle cx="676.014" cy="158.241" r="1.5" transform="rotate(-180 676.014 158.241)" fill="#F24C84" />
        <circle cx="667.919" cy="158.241" r="1.5" transform="rotate(-180 667.919 158.241)" fill="#F24C84" />
        <circle cx="659.824" cy="158.241" r="1.5" transform="rotate(-180 659.824 158.241)" fill="#F24C84" />
        <circle cx="651.729" cy="158.241" r="1.5" transform="rotate(-180 651.729 158.241)" fill="#F24C84" />
        <circle cx="643.635" cy="158.241" r="1.5" transform="rotate(-180 643.635 158.241)" fill="#F24C84" />
        <circle cx="635.541" cy="158.241" r="1.5" transform="rotate(-180 635.541 158.241)" fill="#F24C84" />
        <circle cx="627.446" cy="158.241" r="1.5" transform="rotate(-180 627.446 158.241)" fill="#F24C84" />
        <circle cx="619.352" cy="158.241" r="1.5" transform="rotate(-180 619.352 158.241)" fill="#F24C84" />
        <circle cx="611.257" cy="158.241" r="1.5" transform="rotate(-180 611.257 158.241)" fill="#F24C84" />
        <circle cx="603.162" cy="158.241" r="1.5" transform="rotate(-180 603.162 158.241)" fill="#F24C84" />
        <circle cx="595.067" cy="158.241" r="1.5" transform="rotate(-180 595.067 158.241)" fill="#F24C84" />
        <circle cx="586.973" cy="158.241" r="1.5" transform="rotate(-180 586.973 158.241)" fill="#F24C84" />
        <circle cx="578.879" cy="158.241" r="1.5" transform="rotate(-180 578.879 158.241)" fill="#F24C84" />
        <circle cx="570.784" cy="158.241" r="1.5" transform="rotate(-180 570.784 158.241)" fill="#F24C84" />
        <circle cx="562.689" cy="158.241" r="1.5" transform="rotate(-180 562.689 158.241)" fill="#F24C84" />
        <circle cx="554.595" cy="158.241" r="1.5" transform="rotate(-180 554.595 158.241)" fill="#F24C84" />
        <circle cx="546.5" cy="158.241" r="1.5" transform="rotate(-180 546.5 158.241)" fill="#F24C84" />
        <circle cx="538.405" cy="158.241" r="1.5" transform="rotate(-180 538.405 158.241)" fill="#F24C84" />
        <circle cx="530.311" cy="158.241" r="1.5" transform="rotate(-180 530.311 158.241)" fill="#F24C84" />
        <circle cx="522.216" cy="158.241" r="1.5" transform="rotate(-180 522.216 158.241)" fill="#F24C84" />
        <circle cx="514.122" cy="158.241" r="1.5" transform="rotate(-180 514.122 158.241)" fill="#F24C84" />
        <circle cx="506.027" cy="158.241" r="1.5" transform="rotate(-180 506.027 158.241)" fill="#F24C84" />
        <circle cx="497.933" cy="158.241" r="1.5" transform="rotate(-180 497.933 158.241)" fill="#F24C84" />
        <circle cx="489.838" cy="158.241" r="1.5" transform="rotate(-180 489.838 158.241)" fill="#F24C84" />
        <circle cx="481.743" cy="158.241" r="1.5" transform="rotate(-180 481.743 158.241)" fill="#F24C84" />
        <circle cx="473.648" cy="158.241" r="1.5" transform="rotate(-180 473.648 158.241)" fill="#F24C84" />
        <circle cx="465.554" cy="158.241" r="1.5" transform="rotate(-180 465.554 158.241)" fill="#F24C84" />
        <circle cx="457.459" cy="158.241" r="1.5" transform="rotate(-180 457.459 158.241)" fill="#F24C84" />
        <circle cx="449.365" cy="158.241" r="1.5" transform="rotate(-180 449.365 158.241)" fill="#F24C84" />
        <circle cx="441.271" cy="158.241" r="1.5" transform="rotate(-180 441.271 158.241)" fill="#F24C84" />
        <circle cx="433.176" cy="158.241" r="1.5" transform="rotate(-180 433.176 158.241)" fill="#F24C84" />
        <circle cx="425.081" cy="158.241" r="1.5" transform="rotate(-180 425.081 158.241)" fill="#F24C84" />
        <circle cx="416.986" cy="158.241" r="1.5" transform="rotate(-180 416.986 158.241)" fill="#F24C84" />
        <circle cx="408.892" cy="158.241" r="1.5" transform="rotate(-180 408.892 158.241)" fill="#F24C84" />
        <circle cx="400.797" cy="158.241" r="1.5" transform="rotate(-180 400.797 158.241)" fill="#F24C84" />
        <circle cx="392.702" cy="158.241" r="1.5" transform="rotate(-180 392.702 158.241)" fill="#F24C84" />
        <circle cx="384.608" cy="158.241" r="1.5" transform="rotate(-180 384.608 158.241)" fill="#F24C84" />
        <circle cx="376.514" cy="158.241" r="1.5" transform="rotate(-180 376.514 158.241)" fill="#F24C84" />
        <circle cx="368.419" cy="158.241" r="1.5" transform="rotate(-180 368.419 158.241)" fill="#F24C84" />
        <circle cx="360.324" cy="158.241" r="1.5" transform="rotate(-180 360.324 158.241)" fill="#F24C84" />
        <circle cx="352.229" cy="158.241" r="1.5" transform="rotate(-180 352.229 158.241)" fill="#F24C84" />
        <circle cx="344.135" cy="158.241" r="1.5" transform="rotate(-180 344.135 158.241)" fill="#F24C84" />
        <circle cx="336.04" cy="158.241" r="1.5" transform="rotate(-180 336.04 158.241)" fill="#F24C84" />
        <circle cx="327.945" cy="158.241" r="1.5" transform="rotate(-180 327.945 158.241)" fill="#F24C84" />
        <circle cx="319.852" cy="158.241" r="1.5" transform="rotate(-180 319.852 158.241)" fill="#F24C84" />
        <circle cx="311.757" cy="158.241" r="1.5" transform="rotate(-180 311.757 158.241)" fill="#F04586" />
        <circle cx="303.662" cy="158.241" r="1.5" transform="rotate(-180 303.662 158.241)" fill="#F04586" />
        <circle cx="295.567" cy="158.241" r="1.5" transform="rotate(-180 295.567 158.241)" fill="#F04586" />
        <circle cx="287.473" cy="158.241" r="1.5" transform="rotate(-180 287.473 158.241)" fill="#F04586" />
        <circle cx="279.378" cy="158.241" r="1.5" transform="rotate(-180 279.378 158.241)" fill="#F04586" />
        <circle cx="271.283" cy="158.241" r="1.5" transform="rotate(-180 271.283 158.241)" fill="#F04586" />
        <circle cx="263.188" cy="158.241" r="1.5" transform="rotate(-180 263.188 158.241)" fill="#F04586" />
        <circle cx="255.095" cy="158.241" r="1.5" transform="rotate(-180 255.095 158.241)" fill="#F04586" />
        <circle cx="247" cy="158.241" r="1.5" transform="rotate(-180 247 158.241)" fill="#F04586" />
      </mask>
      <g mask="url(#mask0_2361_7302)">
        <rect
          x="872.977"
          y="121.315"
          width="105.384"
          height="628.42"
          transform="rotate(90 872.977 121.315)"
          fill="url(#paint3_linear_2361_7302)"
        />
      </g>
      <mask
        id="mask1_2361_7302"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="696"
        y="355"
        width="4"
        height="726"
      >
        <circle cx="698.3" cy="357.019" r="1.5" transform="rotate(90 698.3 357.019)" fill="#F24C84" />
        <circle cx="698.3" cy="366.782" r="1.5" transform="rotate(90 698.3 366.782)" fill="#F24C84" />
        <circle cx="698.3" cy="376.545" r="1.5" transform="rotate(90 698.3 376.545)" fill="#F24C84" />
        <circle cx="698.3" cy="386.308" r="1.5" transform="rotate(90 698.3 386.308)" fill="#F24C84" />
        <circle cx="698.3" cy="396.072" r="1.5" transform="rotate(90 698.3 396.072)" fill="#F24C84" />
        <circle cx="698.3" cy="405.835" r="1.5" transform="rotate(90 698.3 405.835)" fill="#F24C84" />
        <circle cx="698.3" cy="415.598" r="1.5" transform="rotate(90 698.3 415.598)" fill="#F24C84" />
        <circle cx="698.3" cy="425.361" r="1.5" transform="rotate(90 698.3 425.361)" fill="#F24C84" />
        <circle cx="698.3" cy="435.125" r="1.5" transform="rotate(90 698.3 435.125)" fill="#F24C84" />
        <circle cx="698.3" cy="444.888" r="1.5" transform="rotate(90 698.3 444.888)" fill="#F24C84" />
        <circle cx="698.3" cy="454.651" r="1.5" transform="rotate(90 698.3 454.651)" fill="#F24C84" />
        <circle cx="698.3" cy="464.415" r="1.5" transform="rotate(90 698.3 464.415)" fill="#F24C84" />
        <circle cx="698.3" cy="474.178" r="1.5" transform="rotate(90 698.3 474.178)" fill="#F24C84" />
        <circle cx="698.3" cy="483.941" r="1.5" transform="rotate(90 698.3 483.941)" fill="#F24C84" />
        <circle cx="698.3" cy="493.704" r="1.5" transform="rotate(90 698.3 493.704)" fill="#F24C84" />
        <circle cx="698.3" cy="503.467" r="1.5" transform="rotate(90 698.3 503.467)" fill="#F24C84" />
        <circle cx="698.3" cy="513.23" r="1.5" transform="rotate(90 698.3 513.23)" fill="#F24C84" />
        <circle cx="698.3" cy="522.994" r="1.5" transform="rotate(90 698.3 522.994)" fill="#F24C84" />
        <circle cx="698.3" cy="532.757" r="1.5" transform="rotate(90 698.3 532.757)" fill="#F24C84" />
        <circle cx="698.3" cy="542.521" r="1.5" transform="rotate(90 698.3 542.521)" fill="#F24C84" />
        <circle cx="698.3" cy="552.284" r="1.5" transform="rotate(90 698.3 552.284)" fill="#F24C84" />
        <circle cx="698.3" cy="562.047" r="1.5" transform="rotate(90 698.3 562.047)" fill="#F24C84" />
        <circle cx="698.3" cy="571.81" r="1.5" transform="rotate(90 698.3 571.81)" fill="#F24C84" />
        <circle cx="698.3" cy="581.574" r="1.5" transform="rotate(90 698.3 581.574)" fill="#F24C84" />
        <circle cx="698.3" cy="591.337" r="1.5" transform="rotate(90 698.3 591.337)" fill="#F24C84" />
        <circle cx="698.3" cy="601.1" r="1.5" transform="rotate(90 698.3 601.1)" fill="#F24C84" />
        <circle cx="698.3" cy="610.863" r="1.5" transform="rotate(90 698.3 610.863)" fill="#F24C84" />
        <circle cx="698.3" cy="620.626" r="1.5" transform="rotate(90 698.3 620.626)" fill="#F24C84" />
        <circle cx="698.3" cy="630.39" r="1.5" transform="rotate(90 698.3 630.39)" fill="#F24C84" />
        <circle cx="698.3" cy="640.153" r="1.5" transform="rotate(90 698.3 640.153)" fill="#F24C84" />
        <circle cx="698.3" cy="649.917" r="1.5" transform="rotate(90 698.3 649.917)" fill="#F24C84" />
        <circle cx="698.3" cy="659.68" r="1.5" transform="rotate(90 698.3 659.68)" fill="#F24C84" />
        <circle cx="698.3" cy="669.443" r="1.5" transform="rotate(90 698.3 669.443)" fill="#F24C84" />
        <circle cx="698.3" cy="679.206" r="1.5" transform="rotate(90 698.3 679.206)" fill="#F24C84" />
        <circle cx="698.3" cy="688.969" r="1.5" transform="rotate(90 698.3 688.969)" fill="#F24C84" />
        <circle cx="698.3" cy="698.732" r="1.5" transform="rotate(90 698.3 698.732)" fill="#F24C84" />
        <circle cx="698.3" cy="708.496" r="1.5" transform="rotate(90 698.3 708.496)" fill="#F24C84" />
        <circle cx="698.3" cy="718.259" r="1.5" transform="rotate(90 698.3 718.259)" fill="#F24C84" />
        <circle cx="698.3" cy="728.022" r="1.5" transform="rotate(90 698.3 728.022)" fill="#F24C84" />
        <circle cx="698.3" cy="737.786" r="1.5" transform="rotate(90 698.3 737.786)" fill="#F24C84" />
        <circle cx="698.3" cy="747.549" r="1.5" transform="rotate(90 698.3 747.549)" fill="#F24C84" />
        <circle cx="698.3" cy="757.312" r="1.5" transform="rotate(90 698.3 757.312)" fill="#F24C84" />
        <circle cx="698.3" cy="767.075" r="1.5" transform="rotate(90 698.3 767.075)" fill="#F24C84" />
        <circle cx="698.3" cy="776.838" r="1.5" transform="rotate(90 698.3 776.838)" fill="#F24C84" />
        <circle cx="698.3" cy="786.602" r="1.5" transform="rotate(90 698.3 786.602)" fill="#F24C84" />
        <circle cx="698.3" cy="796.365" r="1.5" transform="rotate(90 698.3 796.365)" fill="#F24C84" />
        <circle cx="698.3" cy="806.128" r="1.5" transform="rotate(90 698.3 806.128)" fill="#F24C84" />
        <circle cx="698.3" cy="815.892" r="1.5" transform="rotate(90 698.3 815.892)" fill="#F24C84" />
        <circle cx="698.3" cy="825.655" r="1.5" transform="rotate(90 698.3 825.655)" fill="#F24C84" />
        <circle cx="698.3" cy="835.418" r="1.5" transform="rotate(90 698.3 835.418)" fill="#F24C84" />
        <circle cx="698.3" cy="845.181" r="1.5" transform="rotate(90 698.3 845.181)" fill="#F24C84" />
        <circle cx="698.3" cy="854.944" r="1.5" transform="rotate(90 698.3 854.944)" fill="#F24C84" />
        <circle cx="698.3" cy="864.708" r="1.5" transform="rotate(90 698.3 864.708)" fill="#F24C84" />
        <circle cx="698.3" cy="874.471" r="1.5" transform="rotate(90 698.3 874.471)" fill="#F24C84" />
        <circle cx="698.3" cy="884.234" r="1.5" transform="rotate(90 698.3 884.234)" fill="#F24C84" />
        <circle cx="698.3" cy="893.998" r="1.5" transform="rotate(90 698.3 893.998)" fill="#F24C84" />
        <circle cx="698.3" cy="903.761" r="1.5" transform="rotate(90 698.3 903.761)" fill="#F24C84" />
        <circle cx="698.3" cy="913.524" r="1.5" transform="rotate(90 698.3 913.524)" fill="#F24C84" />
        <circle cx="698.3" cy="923.287" r="1.5" transform="rotate(90 698.3 923.287)" fill="#F24C84" />
        <circle cx="698.3" cy="933.05" r="1.5" transform="rotate(90 698.3 933.05)" fill="#F24C84" />
        <circle cx="698.3" cy="942.813" r="1.5" transform="rotate(90 698.3 942.813)" fill="#F24C84" />
        <circle cx="698.3" cy="952.577" r="1.5" transform="rotate(90 698.3 952.577)" fill="#F24C84" />
        <circle cx="698.3" cy="962.34" r="1.5" transform="rotate(90 698.3 962.34)" fill="#F24C84" />
        <circle cx="698.3" cy="972.104" r="1.5" transform="rotate(90 698.3 972.104)" fill="#F24C84" />
        <circle cx="698.3" cy="981.867" r="1.5" transform="rotate(90 698.3 981.867)" fill="#F24C84" />
        <circle cx="698.3" cy="991.63" r="1.5" transform="rotate(90 698.3 991.63)" fill="#F24C84" />
        <circle cx="698.3" cy="1001.39" r="1.5" transform="rotate(90 698.3 1001.39)" fill="#F04586" />
        <circle cx="698.3" cy="1011.16" r="1.5" transform="rotate(90 698.3 1011.16)" fill="#F04586" />
        <circle cx="698.3" cy="1020.92" r="1.5" transform="rotate(90 698.3 1020.92)" fill="#F04586" />
        <circle cx="698.3" cy="1030.68" r="1.5" transform="rotate(90 698.3 1030.68)" fill="#F04586" />
        <circle cx="698.3" cy="1040.45" r="1.5" transform="rotate(90 698.3 1040.45)" fill="#F04586" />
        <circle cx="698.3" cy="1050.21" r="1.5" transform="rotate(90 698.3 1050.21)" fill="#F04586" />
        <circle cx="698.3" cy="1059.97" r="1.5" transform="rotate(90 698.3 1059.97)" fill="#F04586" />
        <circle cx="698.3" cy="1069.74" r="1.5" transform="rotate(90 698.3 1069.74)" fill="#F04586" />
        <circle cx="698.3" cy="1079.5" r="1.5" transform="rotate(90 698.3 1079.5)" fill="#F04586" />
      </mask>
      <g mask="url(#mask1_2361_7302)">
        <rect x="653.8" y="424.816" width="127" height="757.32" fill="url(#paint4_linear_2361_7302)" />
      </g>
      <mask
        id="mask2_2361_7302"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="771"
        y="-331"
        width="4"
        height="726"
      >
        <circle cx="773.3" cy="2.45068" r="1.5" transform="rotate(90 773.3 2.45068)" fill="#F24C84" />
        <circle cx="773.3" cy="12.2139" r="1.5" transform="rotate(90 773.3 12.2139)" fill="#F24C84" />
        <circle cx="773.3" cy="21.9771" r="1.5" transform="rotate(90 773.3 21.9771)" fill="#F24C84" />
        <circle cx="773.3" cy="31.7402" r="1.5" transform="rotate(90 773.3 31.7402)" fill="#F24C84" />
        <circle cx="773.3" cy="41.5039" r="1.5" transform="rotate(90 773.3 41.5039)" fill="#F24C84" />
        <circle cx="773.3" cy="51.2671" r="1.5" transform="rotate(90 773.3 51.2671)" fill="#F24C84" />
        <circle cx="773.3" cy="61.0303" r="1.5" transform="rotate(90 773.3 61.0303)" fill="#F24C84" />
        <circle cx="773.3" cy="70.7935" r="1.5" transform="rotate(90 773.3 70.7935)" fill="#F24C84" />
        <circle cx="773.3" cy="80.5566" r="1.5" transform="rotate(90 773.3 80.5566)" fill="#F24C84" />
        <circle cx="773.3" cy="90.3198" r="1.5" transform="rotate(90 773.3 90.3198)" fill="#F24C84" />
        <circle cx="773.3" cy="100.083" r="1.5" transform="rotate(90 773.3 100.083)" fill="#F24C84" />
        <circle cx="773.3" cy="109.846" r="1.5" transform="rotate(90 773.3 109.846)" fill="#F24C84" />
        <circle cx="773.3" cy="119.61" r="1.5" transform="rotate(90 773.3 119.61)" fill="#F24C84" />
        <circle cx="773.3" cy="129.373" r="1.5" transform="rotate(90 773.3 129.373)" fill="#F24C84" />
        <circle cx="773.3" cy="139.136" r="1.5" transform="rotate(90 773.3 139.136)" fill="#F24C84" />
        <circle cx="773.3" cy="148.899" r="1.5" transform="rotate(90 773.3 148.899)" fill="#F24C84" />
        <circle cx="773.3" cy="158.663" r="1.5" transform="rotate(90 773.3 158.663)" fill="#F24C84" />
        <circle cx="773.3" cy="168.426" r="1.5" transform="rotate(90 773.3 168.426)" fill="#F24C84" />
        <circle cx="773.3" cy="178.189" r="1.5" transform="rotate(90 773.3 178.189)" fill="#F24C84" />
        <circle cx="773.3" cy="187.952" r="1.5" transform="rotate(90 773.3 187.952)" fill="#F24C84" />
        <circle cx="773.3" cy="197.716" r="1.5" transform="rotate(90 773.3 197.716)" fill="#F24C84" />
        <circle cx="773.3" cy="207.479" r="1.5" transform="rotate(90 773.3 207.479)" fill="#F24C84" />
        <circle cx="773.3" cy="217.242" r="1.5" transform="rotate(90 773.3 217.242)" fill="#F24C84" />
        <circle cx="773.3" cy="227.005" r="1.5" transform="rotate(90 773.3 227.005)" fill="#F24C84" />
        <circle cx="773.3" cy="236.769" r="1.5" transform="rotate(90 773.3 236.769)" fill="#F24C84" />
        <circle cx="773.3" cy="246.532" r="1.5" transform="rotate(90 773.3 246.532)" fill="#F24C84" />
        <circle cx="773.3" cy="256.295" r="1.5" transform="rotate(90 773.3 256.295)" fill="#F24C84" />
        <circle cx="773.3" cy="266.059" r="1.5" transform="rotate(90 773.3 266.059)" fill="#F24C84" />
        <circle cx="773.3" cy="275.822" r="1.5" transform="rotate(90 773.3 275.822)" fill="#F24C84" />
        <circle cx="773.3" cy="285.585" r="1.5" transform="rotate(90 773.3 285.585)" fill="#F24C84" />
        <circle cx="773.3" cy="295.348" r="1.5" transform="rotate(90 773.3 295.348)" fill="#F24C84" />
        <circle cx="773.3" cy="305.111" r="1.5" transform="rotate(90 773.3 305.111)" fill="#F24C84" />
        <circle cx="773.3" cy="314.875" r="1.5" transform="rotate(90 773.3 314.875)" fill="#F04586" />
        <circle cx="773.3" cy="324.638" r="1.5" transform="rotate(90 773.3 324.638)" fill="#F04586" />
        <circle cx="773.3" cy="334.401" r="1.5" transform="rotate(90 773.3 334.401)" fill="#F04586" />
        <circle cx="773.3" cy="344.164" r="1.5" transform="rotate(90 773.3 344.164)" fill="#F04586" />
        <circle cx="773.3" cy="353.928" r="1.5" transform="rotate(90 773.3 353.928)" fill="#F04586" />
        <circle cx="773.3" cy="363.691" r="1.5" transform="rotate(90 773.3 363.691)" fill="#F04586" />
        <circle cx="773.3" cy="373.454" r="1.5" transform="rotate(90 773.3 373.454)" fill="#F04586" />
        <circle cx="773.3" cy="383.217" r="1.5" transform="rotate(90 773.3 383.217)" fill="#F04586" />
        <circle cx="773.3" cy="392.98" r="1.5" transform="rotate(90 773.3 392.98)" fill="#F04586" />
      </mask>
      <g mask="url(#mask2_2361_7302)">
        <rect x="728.8" y="-361.702" width="127" height="757.32" fill="url(#paint5_linear_2361_7302)" />
      </g>
      <path
        d="M225.5 328.902V293.335V293.335C225.5 292.874 225.874 292.5 226.335 292.5H261.111"
        stroke="url(#paint6_linear_2361_7302)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M609.405 292.5H645.016V292.5C645.478 292.5 645.852 292.874 645.852 293.336V328.067"
        stroke="url(#paint7_linear_2361_7302)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M645.852 675.98V711.547V711.547C645.852 712.009 645.478 712.382 645.017 712.382H610.241"
        stroke="url(#paint8_linear_2361_7302)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M261.947 712.382H226.336V712.382C225.874 712.382 225.5 712.008 225.5 711.547V676.815"
        stroke="url(#paint9_linear_2361_7302)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M438.5 257.5L438.5 217.5" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M438.366 749.538V789.538" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M685.5 502.5L755.5 502.5" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M191.5 503.123H121.5" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <g filter="url(#filter4_d_2361_7302)">
        <path
          d="M518.016 353.299C517.01 353.757 515.82 353.314 515.403 352.291C511.944 343.806 510.89 334.516 512.376 325.447C513.971 315.72 518.418 306.685 525.153 299.487C531.888 292.29 540.609 287.254 550.209 285.018C559.81 282.782 569.858 283.447 579.08 286.928C588.302 290.409 596.283 296.55 602.011 304.572C607.74 312.594 610.958 322.136 611.257 331.989C611.556 341.842 608.923 351.562 603.692 359.917C598.816 367.706 591.886 373.981 583.682 378.065C582.693 378.557 581.507 378.103 581.055 377.095L572.553 358.14C572.101 357.132 572.556 355.956 573.524 355.424C577.26 353.375 580.421 350.4 582.694 346.77C585.321 342.573 586.644 337.69 586.494 332.741C586.343 327.792 584.727 322.999 581.849 318.969C578.972 314.94 574.963 311.855 570.331 310.106C565.698 308.358 560.651 308.024 555.828 309.147C551.006 310.27 546.626 312.8 543.242 316.415C539.859 320.03 537.626 324.569 536.824 329.455C536.132 333.682 536.538 338.004 537.988 342.01C538.364 343.049 537.928 344.233 536.923 344.69L518.016 353.299Z"
          fill="url(#paint10_linear_2361_7302)"
          fillOpacity="0.6"
        />
        <path
          d="M579.054 377.939C579.46 378.966 578.957 380.132 577.914 380.496C568.067 383.935 557.386 384.194 547.384 381.237C546.325 380.923 545.766 379.783 546.122 378.737L552.845 358.959C553.201 357.913 554.336 357.362 555.407 357.633C559.803 358.743 564.42 358.631 568.757 357.309C569.813 356.987 570.973 357.482 571.379 358.51L579.054 377.939Z"
          fill="url(#paint11_linear_2361_7302)"
          fillOpacity="0.6"
        />
        <path
          d="M544.208 378.041C543.808 379.071 542.647 379.585 541.635 379.144C531.593 374.774 523.271 367.212 517.962 357.634C517.426 356.668 517.827 355.463 518.814 354.967L537.477 345.581C538.464 345.085 539.659 345.488 540.233 346.432C542.723 350.527 546.344 353.817 550.659 355.905C551.653 356.386 552.168 357.538 551.768 358.567L544.208 378.041Z"
          fill="url(#paint12_linear_2361_7302)"
          fillOpacity="0.6"
        />
      </g>
      <rect
        x="235.25"
        y="301.25"
        width="32.5"
        height="32.5"
        rx="1.25"
        stroke="url(#paint13_linear_2361_7302)"
        strokeWidth="1.5"
      />
      <rect
        x="606.25"
        y="672.25"
        width="32.5"
        height="32.5"
        rx="1.25"
        stroke="url(#paint14_linear_2361_7302)"
        strokeWidth="1.5"
      />
      <g filter="url(#filter5_d_2361_7302)">
        <circle
          cx="176.5"
          cy="416.5"
          r="42"
          fill="url(#paint15_linear_2361_7302)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2361_7302"
          x="238.755"
          y="303.485"
          width="407.991"
          height="406.029"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9" dy="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_7302" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_7302" result="shape" />
        </filter>
        <filter
          id="filter1_d_2361_7302"
          x="0"
          y="561.5"
          width="150"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_7302" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_7302" result="shape" />
        </filter>
        <filter
          id="filter2_d_2361_7302"
          x="648"
          y="737.5"
          width="147"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_7302" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_7302" result="shape" />
        </filter>
        <filter
          id="filter3_d_2361_7302"
          x="518"
          y="195.5"
          width="194"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_7302" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_7302" result="shape" />
        </filter>
        <filter
          id="filter4_d_2361_7302"
          x="511.721"
          y="283.721"
          width="107.559"
          height="107.559"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_7302" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_7302" result="shape" />
        </filter>
        <filter
          id="filter5_d_2361_7302"
          x="134.5"
          y="374.5"
          width="92"
          height="92"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_7302" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_7302" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2361_7302"
          x1="-0.217733"
          y1="561.273"
          x2="167.284"
          y2="592.353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2361_7302"
          x1="647.787"
          y1="737.273"
          x2="811.978"
          y2="767.095"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2361_7302"
          x1="517.715"
          y1="195.273"
          x2="732.014"
          y2="247.357"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2361_7302"
          x1="920.69"
          y1="350.604"
          x2="1027.69"
          y2="383.749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA627A" stopOpacity="0.22" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" stopOpacity="0.33" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2361_7302"
          x1="717.8"
          y1="560"
          x2="882.084"
          y2="610.654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5A5A" stopOpacity="0" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2361_7302"
          x1="786.3"
          y1="-85.3825"
          x2="915.253"
          y2="-45.4392"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA627A" stopOpacity="0.22" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" stopOpacity="0.33" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2361_7302"
          x1="225.445"
          y1="292.367"
          x2="268.627"
          y2="295.789"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2361_7302"
          x1="609.349"
          y1="292.37"
          x2="653.518"
          y2="296.037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2361_7302"
          x1="610.187"
          y1="675.847"
          x2="653.368"
          y2="679.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2361_7302"
          x1="225.444"
          y1="676.685"
          x2="269.612"
          y2="680.352"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2361_7302"
          x1="579.959"
          y1="265.186"
          x2="631.837"
          y2="374.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2361_7302"
          x1="579.959"
          y1="265.186"
          x2="631.837"
          y2="374.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2361_7302"
          x1="579.959"
          y1="265.186"
          x2="631.837"
          y2="374.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2361_7302"
          x1="234.448"
          y1="300.376"
          x2="275.664"
          y2="303.715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_2361_7302"
          x1="605.448"
          y1="671.376"
          x2="646.664"
          y2="674.715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_2361_7302"
          x1="134.371"
          y1="374.193"
          x2="236.2"
          y2="382.443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
